import React from "react";
import Banner from "../Banner/Banner";
import WhyChooseMe from "../WhyChooseMe/WhyChooseMe";
import Sarvices from "../Services/Services";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Sarvices></Sarvices>
      <WhyChooseMe></WhyChooseMe>
    </div>
  );
};

export default Home;
